
import {translate} from '@elements/translations';
import {ref, computed, watch, reactive, onMounted, defineComponent, defineEmits} from 'vue';
import {getLanguageConfig} from "../../utils/config-helper.ts";

export default defineComponent({
    name: 'CalendarDate',
    props: {
        day: {
            type: Object,
            required: true
        },
        startDate: {
            type: String,
            required: true
        },
        isSelectedStartDay: {
            type: Boolean,
            required: true
        },
        isSelectedEndDay: {
            type: Boolean,
            required: true
        },
        isDisabled: {
            type: Boolean,
            required: true
        },
        isInRange: {
            type: Boolean,
            required: true
        },
        ticketId: {
            type: String,
            required: true
        },
        defaultPriceGroupId: {
            type: String,
            required: true
        },
    },
    emits: ['selectDate'],
    setup(props, {emit}) {
        const getDay = (date) => {
            //get day (number) of date
            return new Date(date).toLocaleDateString(getLanguageConfig(), {day: 'numeric'});
        };

        return {
            getDay,
            emit,
            translate
        }
    }
})
